module.exports = __webpack_public_path__ + "static/img/landing-screen-v2-4.0d58f9b.png";